import { ICONS } from '@/lib/icons'
import type { LucideIcon } from 'lucide-react'
import { useMemo } from 'react'

// ICONS is generated as a fixed object literal; widen it so arbitrary backend icon names can be looked up.
const iconsByName: Partial<Record<string, LucideIcon>> = ICONS

export type DynamicIconProps = {
  iconName?: string | null
  className?: string
}

/**
 * A component that renders Lucide icons set by the backend.
 * Technically these are not truly *dynamic*, you must run the `php artisan react:enum` command
 * to populate a list in `icons.ts`.
 */
export function DynamicIcon({ iconName, className }: DynamicIconProps) {
  const IconComponent = useMemo(() => {
    if (!iconName) {
      return null
    }

    return iconsByName[iconName] ?? null
  }, [iconName])

  if (!IconComponent) {
    return null
  }

  return <IconComponent className={className} />
}
